import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { UserForm } from './UserForm';

import type { UserModalProps } from './types';

export const UserModal = ({
  open,
  onOpenChange,
  user,
  onSubmit,
  allowProfileEdit = true,
  errors,
  isLoading,
}: UserModalProps) => {
  const isEditing = user !== null;

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/60" />
        <Dialog.Content className="bg-background fixed top-1/2 left-1/2 z-50 max-h-[90vh] w-full max-w-lg -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-lg p-6 shadow-lg">
          <div className="flex items-center justify-between">
            <Dialog.Title className="text-lg font-semibold">
              {isEditing ? 'Edit user' : 'New user'}
            </Dialog.Title>
            <Dialog.Close asChild>
              <Button variant="ghost" size="icon">
                <X className="h-4 w-4" />
              </Button>
            </Dialog.Close>
          </div>
          <div className="mt-4">
            <UserForm
              isEditing={isEditing}
              allowProfileEdit={allowProfileEdit}
              initialValues={
                isEditing
                  ? {
                      name: user?.name,
                      email: user?.email,
                      role: user?.role,
                      configuration_ids: user?.configuration_ids ?? [],
                    }
                  : undefined
              }
              submitLabel={isEditing ? 'Save changes' : 'Create user'}
              onSubmit={onSubmit}
              errors={errors}
              isLoading={isLoading}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
